import { render } from "./DllEdu.vue?vue&type=template&id=24ca8e45"
import script from "./DllEdu.vue?vue&type=script&lang=js"
export * from "./DllEdu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__